<template>
  <div class="w-full max-w-xl py-20 bg-white flex flex-col space-y-20">
    <h2>{{ $t('rewards.send_to_different_address') }}</h2>
    <Card class="p-30 space-y-20">
      <legend class="font-semibold pb-20">
        {{ $t('rewards.reward_confirmation.sending_to') }}
      </legend>
      <Form
        :validator="$v.model"
        :error="error"
        :messages="{
          minLength: $t('registration.contact_info.length_error'),
        }"
      >
        <FormInput
          v-model="model.streetAddr1"
          class="w-full"
          :label="$t('registration.contact_info.street_address_1')"
          name="streetAddr1"
          :placeholder="
            $t('registration.contact_info.street_address_1_place_holder')
          "
          autocomplete="address-line-1"
        />
        <FormInput
          v-model="model.streetAddr2"
          class="mt-16 ml-auto"
          name="streetAddr2"
          :label="$t('registration.contact_info.street_address_2')"
          :placeholder="
            $t('registration.contact_info.street_address_2_place_holder')
          "
          :required="false"
          autocomplete="address-line2"
        />
        <div class="flex flex-wrap py-4 mt-16 ml-auto">
          <FormInput
            v-model="model.city"
            class="w-full md:flex-1"
            name="city"
            :label="$t('registration.contact_info.city')"
            placeholder="New York"
            autocomplete="address-level2"
          />
          <label for="state" class="sr-only">
            {{ $t('registration.contact_info.state') }}
          </label>
          <FormListPicker
            v-model="model.state"
            :compact="true"
            class="w-full pr-4 md:pl-8 md:pr-10 md:flex-1"
            name="state"
            :placeholder="$t('registration.contact_info.state')"
            :label="$t('registration.contact_info.state')"
            autocomplete="address-level1"
            :data="states"
          />
          <FormInput
            v-model="model.zip"
            mask="#####"
            class="w-full md:flex-1"
            name="zip"
            :label="$t('common.zip_code')"
            placeholder="77777"
            autocomplete="postal-code"
          />
        </div>
      </Form>
      <div class="text-grey-500 text-sm mt-10">
        {{ $t('common.does_not_change_contact_info') }}
      </div>
    </Card>
    <div class="mx-auto flex-shrink-0 space-y-20 flex flex-col justify-center">
      <HMButton
        :disabled="isFetching.update"
        padding="wide"
        @click="onComplete"
      >
        {{ $t('common.confirm') }}
      </HMButton>
      <HMButton color="white" outlined padding="wide" @click="promptCancel">
        {{ $t('common.cancel_btn') }}
      </HMButton>
    </div>
    <Modal :active="showModal" @close="closeAndResume">
      <FormExitModal
        :strings="exitModal"
        @confirm="closeAndCancel"
        @cancel="closeAndResume"
      />
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'
import { STATES } from '@platform-shared/constants'
import Card from '@components/common/card/Card'
import Form from '@components/common/forms/Form'
import FormExitModal from '@components/common/forms/FormExitModal'
import FormInput from '@components/common/forms/FormInput'
import FormListPicker from '@components/common/forms/FormListPicker'
import Modal from '@components/common/Modal'

export default {
  components: {
    Card,
    Form,
    FormExitModal,
    FormInput,
    FormListPicker,
    Modal,
  },
  props: {
    exitModal: {
      type: Object,
      default: () => {
        return {
          exitTitle: '',
          exitDescription: '',
          exitConfirm: '',
          exitCancel: '',
        }
      },
    },
  },
  data() {
    return {
      states: STATES,
      model: {
        streetAddr1: '',
        streetAddr2: '',
        city: '',
        state: 'AL',
        zip: '',
      },
      error: null,
      showModal: false,
    }
  },
  validations: {
    model: {
      streetAddr1: { required },
      streetAddr2: {},
      city: { required },
      state: { required },
      zip: {
        required,
        validZipCode: minLength(5),
      },
    },
  },
  computed: {
    ...mapGetters('member', ['memberInfo', 'isFetching']),
  },
  methods: {
    onComplete() {
      this.error = null
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.$emit('continue', { ...this.model })
    },
    promptCancel() {
      this.showModal = true
    },
    closeAndCancel() {
      this.$emit('cancel')
      this.showModal = false
    },
    closeAndResume() {
      this.showModal = false
    },
  },
}
</script>
<style></style>
